"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "Login",
  data: function data() {
    var validatePassword = function validatePassword(rule, value, callback) {
      if (value.length < 6) {
        callback(new Error("账号密码长度应大于6"));
      } else {
        callback();
      }
    };

    return {
      logo: require("../../assets/image/jz-logo.png"),
      loginForm: {
        username: "",
        password: "",
        userType: "0",
        verifyCode: ""
      },
      loginRules: {
        username: [{
          required: true,
          message: "登录账号不能为空",
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: "登录密码不能为空",
          trigger: "blur"
        }, {
          validator: validatePassword,
          trigger: "blur"
        }],
        verifyCode: [{
          required: true,
          message: "验证码不能为空",
          trigger: "blur"
        }]
      },
      passwordType: "password",
      loading: false
    };
  },
  watch: {
    $route: {
      handler: function handler(route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.getCaptcha();
  },
  methods: {
    getCaptcha: function getCaptcha() {
      console.info('get verifyCode');
      this.$store.dispatch('verifyCode').then(function (res) {
        var blob = new Blob([res.data], {
          type: res.data.type
        });
        document.getElementById('code').src = URL.createObjectURL(blob);
      });
    },
    handleLogin: function handleLogin() {
      var _this = this;

      this.$refs.loginForm.validate(function (valid) {
        if (valid && !_this.loading) {
          _this.loading = true;

          _this.$store.dispatch("LoginByUsername", _this.loginForm).then(function () {
            _this.loading = false;

            _this.$router.push({
              path: _this.redirect || "/"
            });
          }).catch(function (err) {
            console.info(err);
            _this.loading = false;

            _this.$message.error(err.data.errmsg);

            _this.getCaptcha();
          });
        } else {
          return false;
        }
      });
    }
  }
};
exports.default = _default;